module.exports = __webpack_public_path__ + "static/media/exit-up.060ec131.svg";